/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/models/train-wheel.glb -o src/components-3d/TrainWheel.jsx 
*/

import React, { useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import { useSmartTexture } from '../hooks/useSmartTexture.js'
import * as THREE from 'three'

export function TrainWheel({ autoPlay, ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/models/train-wheel.glb')
  const { actions } = useAnimations(animations, group)
  
  const bakedTexture = useSmartTexture('train-wheel')
  bakedTexture.flipY = false

  React.useEffect(() => {
    if (actions && Object.keys(actions).length > 0) {
      const firstAction = Object.values(actions)[0]
      if (firstAction) {
        if (autoPlay) {
          // Play the animation during autoplay
          firstAction.reset().play()
          firstAction.setLoop(THREE.LoopRepeat, Infinity)
          firstAction.timeScale = 5 // Increase speed to 5x
        } else {
          // Stop the animation when autoplay ends
          firstAction.stop()
        }
      }
    }
  }, [actions, autoPlay])

  return (
    <group ref={group} {...props} dispose={null} scale={100}>
      <group name="Scene">
        <group
          name="train-wheels"
          position={[-2.667, 0.189, 1.494]}
          rotation={[-0.037, 1.552, 0.069]}
          scale={0.285}>
          <skinnedMesh
            name="Loco_sideRod_wheel_back001"
            geometry={nodes.Loco_sideRod_wheel_back001.geometry}
            skeleton={nodes.Loco_sideRod_wheel_back001.skeleton}
          >
            <meshBasicMaterial map={bakedTexture} />
          </skinnedMesh>
          <primitive object={nodes.WHEEL1} />
          <primitive object={nodes.WHEEL2} />
          <primitive object={nodes.WHEEL3} />
          <primitive object={nodes.main} />
          <primitive object={nodes.rod} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/train-wheel.glb')
